import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=ab5b75ac&"
import script from "./UserItem.vue?vue&type=script&lang=js&"
export * from "./UserItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports